import { CQAppConstant } from '../../app-constants';

interface IFormRuleFilter {
	fieldsArray: string[];
	filterCriteria: any;
}

interface IGenerateFiltersArgs {
	criteriaFilterString: string[];
	referenceFieldInCriteria: string[];
}

export abstract class BaseRuleController<T> {
	protected abstract generateFilterString(criterias: T[]): IGenerateFiltersArgs;
 
	/**
	 * @description To construct filter string in te rule
	 * @param complexLogic rule logic used for criteria fields
	 * @param criterias contains property for field selected
	 */
	protected formFilterString(complexLogic: string, criterias: T[]) {
		let filterJSExpression = this.replaceLogicOperators(complexLogic);
		const { criteriaFilterString, referenceFieldInCriteria } = this.generateFilterString(criterias);
		
		if (criteriaFilterString.length > 1) {
			const numberMatches = complexLogic.match(/\d+/g);
			numberMatches?.forEach((match) => {
				filterJSExpression = filterJSExpression.replace(match, `%%${match}%%`);
			});
			if (numberMatches) {
				numberMatches.forEach((match) => {
					filterJSExpression = filterJSExpression.replace(
						`%%${match}%%`,
						criteriaFilterString[parseInt(match) - 1]
					);
				});
			}
		} else if (criteriaFilterString.length === 1) {
			filterJSExpression = criteriaFilterString[0];
		}

		return referenceFieldInCriteria.length !== 0
			? this.constructFilterStringForRefereceCritetias(filterJSExpression, referenceFieldInCriteria)
			: filterJSExpression;
	}

	/**
	 * @description To convert if boolean value present in text into boolean type
	 * @param text string for comparision in rule
	 */
	protected covertStringIfIBooleanType(text: string) {
		if (text === 'true') {
			return true;
		} else if (text === 'false') {
			return false;
		} else if (text === '') {
			return text;
		} else {
			return `'${text}'`;
		}
	}

	 /**
     * @param {string} text
     * @returns text
     */
	  protected covertActionValueStringIfIBooleanType(text: string) {
        if (text === 'true') {
            return true;
        } else if (text === 'false') {
            return false;
        } else if (text === '') {
            return text;
        } else {
            return text;
        }
    }

	/**
	 * @description To construct filter string in rule
	 * @param filterJSExpression
	 */
	protected replaceLogicOperators(filterJSExpression: string) {
		const regExANDTerm = new RegExp(` ${CQAppConstant.AND_OPERATOR} `, 'g');
		const regExORTerm = new RegExp(` ${CQAppConstant.OR_OPERATOR} `, 'g');
		const regExpandTerm = new RegExp(` ${CQAppConstant.AND_OPERATOR.toLowerCase()} `, 'g');
		const regExorTerm = new RegExp(` ${CQAppConstant.OR_OPERATOR.toLowerCase()} `, 'g');
		filterJSExpression = filterJSExpression.replace(regExANDTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.AND} `);
		filterJSExpression = filterJSExpression.replace(regExORTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.OR} `);
		filterJSExpression = filterJSExpression.replace(regExpandTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.AND} `);
		filterJSExpression = filterJSExpression.replace(regExorTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.OR} `);

		return filterJSExpression;
	}

	/**
	 * @description to construct filter expression when refernce field is added
	 * @param filterJSExpression
	 * @param referenceFieldInCriteria
	 */
	private constructFilterStringForRefereceCritetias(filterJSExpression: string, referenceFieldInCriteria: string[]) {
		let filterString = '';
		referenceFieldInCriteria = Array.from(new Set(referenceFieldInCriteria));
		referenceFieldInCriteria.forEach((referenceTypeField: string) => {
			filterString = `${filterString} ${
				referenceTypeField === 'customSettings' ? '' : CQAppConstant.RECORD
			}${referenceTypeField} ${CQAppConstant.LOGICAL_OPERATORS.AND}`;
		});
		return `${filterString} (${filterJSExpression})`;
	}
}
